import { useParams } from "react-router-dom";

import Container from 'react-bootstrap/Container';
import {APIProvider, Map} from '@vis.gl/react-google-maps';
import RideMarkers from './RideMarkers';

function DayRideMap() {
  const position = {lat: 12.9716, lng: 77.5946}; //Bangalore
  const rideId = useParams().rideId;
  // const navigate = useNavigate();
  
  return (
    <Container style={{height: '85vh'}}>
      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
        {!rideId && <RideMarkers></RideMarkers>}
        {rideId && <RideMarkers rideDate={rideId}></RideMarkers>}
        <Map scaleControl={true} center={position} zoom={16} mapId={process.env.REACT_APP_MAP_ID}>
        </Map>
      </APIProvider>
    </Container>
  )
}

export default DayRideMap;